export class VPN {
    Type: string = "VPN";
    SerialNumber: string;
    Date: Date;
    VPNName: string;
}